import { useFormik } from 'formik'
import { forwardRef, useEffect, useImperativeHandle } from 'react'
import Input from '../../../../../../components/atoms/input/Input'
import Text from '../../../../../../components/atoms/text/Text'
import FormField from '../../../../../../components/molecules/formField/FormField'
import { useProfileAssistant } from '../../../../../../providers/profileAssistant'
import { VARIANTS } from '../../../../../../types/Components.types'
import { IStepProps, IStepRef } from '../types'
import styles from './ProfessionStep.module.css'
import professionFormSchema from './schema/profession'

const ProfessionStep = forwardRef<IStepRef, IStepProps>(({ onSubmit, onIsSubmittingChange }, ref) => {
  const { profession, firstname, setProfession } = useProfileAssistant()

  const { handleSubmit, values, handleChange, handleBlur, touched, errors, isValid, isSubmitting } = useFormik({
    initialValues: {
      profession,
    },
    validationSchema: professionFormSchema,
    onSubmit: async (values) => {
      return new Promise<void>((resolve) => {
        setProfession(values)
        resolve()
        onSubmit?.()
      })
    },
  })

  useImperativeHandle(ref, () => ({
    submit: handleSubmit,
    isValid,
    isSubmitting,
  }))

  useEffect(() => {
    onIsSubmittingChange?.(isSubmitting)
  }, [onIsSubmittingChange, isSubmitting])

  return (
    <div className={styles.content}>
      <Text size="l" variant={VARIANTS.primary} weight="700" className={styles.title}>
        {firstname}, ¿en qué trabajas?
      </Text>

      <Text className={styles.description}>
        Podrás compartir ideas con aquellos compañeros del coworking que trabajen en tu mismo campo de especialización.
      </Text>

      <form onSubmit={handleSubmit}>
        <FormField
          field={
            <Input
              name="profession"
              type="text"
              placeholder="Mi profesión"
              value={values.profession}
              onChange={handleChange}
              onBlur={handleBlur}
            />
          }
          error={touched.profession ? errors.profession : errors.profession}
        />
      </form>
    </div>
  )
})

export default ProfessionStep
